<template>
  <div class="container">
    <div class="contract">
      <div class="head-contract head-top table-responsive">
        <table class="table">
          <tr>
            <td class="text-center">
              <label class="fonsize-16">CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</label>
              <p class="text-center">---------o0o---------</p>
              <p class="text-center">Số: 02/2022/QĐ/VIMO</p>
              <p class="text-center">V/v: Quy định về việc chấm công</p>
            </td>
            <td>&nbsp;</td>
            <td class="text-center">
              <label class="fonsize-16">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</label>
              <p class="f-14 text-center"><b>Độc lập – Tự do – Hạnh Phúc</b></p>
              <p class="text-center">---------o0o---------</p>
              <p class="text-center">
                <em>Hà Nội, ngày 25 tháng 02 năm 2022</em>
              </p>
            </td>
          </tr>
        </table>
      </div>
      <p class="txt-center fonsize-20 txt-tranf"><b>TỔNG GIÁM ĐỐC</b></p>
      <p class="txt-center fonsize-20 magb20">
        <b>CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b>
      </p>
      <p>
        <em>- Căn cứ vào ĐKKD số 0106393643 và Điều lệ của Công ty Cổ phần Công nghệ Vi Mô </em>
      </p>
      <p class="magb20">
        <em>- Căn cứ vào đề xuất của Bộ phận Kinh doanh và tình hình thực tế của Công ty;</em>
      </p>
      <p class="txt-center fonsize-16 txt-tranf magb20">
        <b>QUY ĐỊNH CHẤM CÔNG CỦA BỘ PHẬN KINH DOANH NEXTPAY TOÀN QUỐC</b>
      </p>
      <p class="line-height">
        <b class="txt-under">Điều 1:</b> Thực hiện việc chấm công và báo cáo công việc hằng ngày của
        toàn thể nhân sự thuộc Bộ phận Kinh doanh NextPay toàn quốc và Bộ phận khác ngoài Văn Phòng
        Hà Nội (NextAcademy, BP đào tạo NextPay) trên ứng dụng quản lý nội bộ My NextPay.
      </p>
      <p class="line-height">
        * Miễn trừ chấm công với Giám Đốc Vùng và bộ phận khác khi được Ban Giám đốc phê duyệt.
      </p>
      <p class="line-height">
        <b class="txt-under">Điều 2:</b>
        <b> Quy định chấm công</b> (Check-in/Check-out), chấm công bổ sung, xin nghỉ phép/việc cá
        nhân,... như sau:
      </p>
      <table>
        <thead>
          <tr>
            <th><b class="txt-tranf">Nội dung</b></th>
            <th><b class="txt-tranf">QUY ĐỊNH</b></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="txt-center">
              <b>Chấm công</b> <br />
              <em>(Check in/ Check out)</em>
            </td>
            <td>
              <ul class="list form-style1">
                <li>
                  <h1>hình thức</h1>
                  <ul>
                    <li>▪ Tất cả nhân sự phải Check-in/Check-out qua ứng dụng My NextPay.</li>
                  </ul>
                </li>
                <li>
                  <h1>THỜI GIAN THỰC HIỆN GHI NHẬN CHẤM CÔNG:</h1>
                  <ul>
                    <li>▪ Buổi sáng, Check-in: Từ 7h30.</li>
                    <li>
                      ▪ Buổi chiều các ngày trong tuần, Check-out: Từ 17h30 đến 21h00 (Thứ 7 hàng
                      tuần là 12h00 đến 16h00).
                    </li>
                  </ul>
                </li>
                <li>
                  <h1>YÊU CẦU THỰC HIỆN KHI CHẤM CÔNG</h1>
                  <ul>
                    <li class="line-height">
                      ▪ Địa điểm Check-in/Check-out phải đúng Khu vực Tỉnh/ Thành nơi nhân sự đó
                      đang làm việc; trường hợp nhân sự làm việc ở Tỉnh/ Thành lân cận thì phải được
                      phân công từ cấp Quản lý vùng và thiết lập trên hệ thống My NextPay.
                    </li>
                    <li class="line-height">
                      ▪ Bắt buộc Check-in tại văn phòng làm việc của NextPay tại các địa bàn có văn
                      phòng đối với cấp quản lý từ Trưởng nhóm trở lên và bộ phận làm việc thường
                      xuyên tại văn phòng như: Marketing, Telesales, After Sales Online, Sale Admin
                      hoặc theo đề nghị của Giám đốc vùng kinh doanh yêu cầu.
                    </li>
                    <li class="line-height">
                      ▪ Các trường hợp đối với cấp quản lý, khi đi công tác ở tỉnh khác từ 02 ngày
                      trở lên phải có kế hoạch hoặc nghỉ do dịch bệnh, thiên tai,... thì cần phải
                      thông báo tới cấp quản lý tại địa bàn & được BoD phê duyệt;
                    </li>
                    <li class="line-height">
                      ▪ Khi nhân sự thực hiện Check-in hoặc Check-out qua My NextPay chỉ được ghi
                      nhận là hợp lệ khi có hình ảnh selfie bao quát được khuôn mặt + khung cảnh
                      xung quanh.
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td class="line-height" style="text-align: center !important">
              <b> Chấm công bổ sung hoặc Xin nghỉ phép/nghỉ việc riêng/nghỉ không lương </b>
            </td>
            <td class="line-height">
              <ul class="list form-style1">
                <li class="line-height">
                  ● Chấm công bổ sung, nghỉ phép/ việc riêng/ nghỉ không lương cần tạo yêu cầu trên
                  hệ thống My NextPay, ghi rõ lý do (đi gặp/ ký hợp đồng merchant với tên cụ
                  thể,....) và được các cấp quản lý phê duyệt theo đúng thời gian quy định thì mới
                  coi là hợp lệ. Trường hợp có tạo yêu cầu nhưng không ghi lý do hoặc lý do không
                  phù hợp thì cấp quản lý coi là không hợp lệ và từ chối duyệt. Nếu nghỉ do dịch
                  bệnh, thiên tai thì ngoài việc tạo yêu cầu trên My NextPay cần gửi thêm Email cho
                  các cấp quản lý trực tiếp và bộ phận Hành chính nhân sự (email cnb@vimo.vn) để nắm
                  thông tin và được ghi nhận.
                </li>
                <li class="line-height">
                  ● Các nhân sự ký hợp đồng lao động chính thức được ghi nhận ngày nghỉ phép tối đa
                  03 ngày/ 01 tháng; Cấp quản lý trực tiếp chỉ được phê duyệt 01 ngày nghỉ phép/ 01
                  lần/ 01 tháng. Trường hợp nghỉ liên tiếp từ 02 đến 03 ngày/ 01 tháng cần báo cáo
                  Giám đốc kinh doanh vùng, nếu được đồng ý mới phê duyệt. Trường hợp nghỉ liên tiếp
                  quá 03 ngày tối đa cho phép (không tính theo số lần trong tháng) thì 03 ngày được
                  tính nghỉ có phép (hết phép trừ lương), các ngày nghỉ còn lại được tính nghỉ không
                  lương.
                </li>
                <li class="line-height">
                  ● Trường hợp nghỉ quá 03 ngày liên tiếp/01 lần nghỉ phép phải tạo yêu cầu trên My
                  NextPay, đồng thời phải gửi email cho quản lý cấp vùng xin phê duyệt và đồng thời
                  phải được sự phê duyệt đồng ý của BOD hoặc người được BOD ủy quyền.
                </li>
                <li class="line-height">
                  ● Với nhân sự đang trong giai đoạn thử việc, chưa có ngày phép, nếu nghỉ phép được
                  tính là nghỉ không lương.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="line-height">
        <b class="txt-under">Điều 3:</b>
        <b>Nguyên tắc ghi nhận ngày công làm việc:</b>
      </p>
      <p class="line-height">
        CVKD chỉ được ghi nhận ngày công nếu Check-in & Check-out đúng theo quy định tại
        <b class="txt-under">Điều 2</b> của Quy định này <b class="txt-under">(ĐIỀU KIỆN CẦN)</b> và
        khai báo công việc hàng ngày trên hệ thống My NextPay (như khai báo danh bạ khách hàng mới -
        Leads, công việc đã liên hệ hoặc tư vấn với khách hàng, hợp đồng,...) theo số lượng khách
        hàng mới, số lượng khách hàng được liên hệ hoặc tư vấn,... theo quy định của từng vùng kinh
        doanh <b class="txt-under">(ĐIỀU KIỆN ĐỦ)</b>; trường hợp chấm công bổ sung hoặc xin nghỉ
        phép/ việc cá nhân phải được cấp quản lý phê duyệt trong thời gian quy định.
      </p>
      <p class="line-height">
        <b class="txt-under">Điều 4:</b>
        <b>Trách nhiệm của các cấp quản lý địa bàn khi áp dụng Quy định này:</b>
      </p>
      <ul class="form-style2 style">
        <li>
          Trực tiếp TNKD, TP/GĐT & GĐV phải thực hiện việc kiểm tra, đôn đốc Nhân viên của mình sử
          dụng My NextPay, thực hiện đúng các định mức công việc mỗi ngày theo quy chế chung và quy
          chế của vùng/địa bàn kinh doanh;
        </li>
        <li>
          Trường hợp nhân viên đã xin nghỉ việc cá nhân, nghỉ phép, chấm công bổ sung trên hệ thống
          My NextPay thì người quản lý trực tiếp phải phê duyệt trong vòng 03 ngày làm việc. Quá
          thời gian trên, nếu việc xin nghỉ hoặc chấm công bổ sung hợp lệ, nhân viên vẫn được ghi
          nhận hợp lệ (mà không bị phạt). Nếu quản lý duyệt muộn thì bị phạt 200,000đ/lần duyệt
          chậm.
        </li>
        <li>
          Nếu nhân viên đã thực hiện Check-in và Check-out, nếu Trưởng nhóm kinh doanh hoặc người
          quản lý trực tiếp phê duyệt muộn quá thời gian quy định hoặc duyệt sai quy định thì bị
          phạt 50,000đ/lần (checkin hoặc checkout). Trường hợp phê duyệt muộn mà việc Check-in hoặc
          Check-out của nhân viên hợp lệ (theo quy định của Điều 2 của Quy định này) thì nhân viên
          vẫn được ghi nhận hợp lệ.
        </li>
        <li>
          Trong quá trình thực hiện, nếu các cấp quản lý buông lỏng vai trò quản lý, giám sát
          và/hoặc cổ súy, tiếp tay cho Nhân viên của mình thực hiện các hành vi gian lận sẽ bị xử lý
          nghiêm khắc (bao gồm phạt bằng tiền là 1,000,000đ/ nhân viên đối với TNKD + 500,000đ/nhân
          viên đối với GĐT/TPKD + 300,000đ/nhân viên đối với GĐVKD; hoặc bị xử lý hình thức cao nhất
          là buộc thôi việc theo quyết định của BoD).
        </li>
      </ul>
      <p class="line-height"><b class="txt-under">Điều 5:</b> <b>Quy định ON - OFF nhân sự:</b></p>
      <ul class="form-style2 style">
        <li>
          <b>Với các nhân sự đã thông báo ON </b> nhưng sau đó không nhận việc, quản lý trực tiếp
          phải phản hồi lại thông tin vào luồng email ON nhân sự trong vòng 03 ngày làm việc.
        </li>
        <li>
          <b>Với các nhân sự OFF,</b> quản lý trực tiếp gửi email thông báo OFF nhân sự muộn nhất
          trong vòng 05 ngày kể từ ngày nghỉ việc chính thức của nhân sự và được GĐV phê duyệt.
          <ul>
            <li>
              ● Khi gửi email cần đính kèm đầy đủ thông tin: Họ tên nhân sự - email - ngày ON - Ngày
              OFF - Tình trạng bàn giao - Lý do OFF - Cách tính lương
            </li>
            <li>
              ● Các đầu mối cần cc trong email:
              <ul>
                <li>+ Hr NextPay: <b>hr@vimo.vn</b></li>
                <li>+ Giám sát NextPay: <b>gs@vimo.vn</b></li>
                <li>
                  + Đối với HCM & ĐTNB:
                  <b>hr.hcm.nextpay@peacesoft.net, cnbhcm@peacesoft.net</b>
                </li>
                <li>
                  + Đối với các vùng còn lại:
                  <b>hr.hn.nextpay@peacesoft.net, cnbsupport@peacesoft.net</b>
                </li>
                <li>+ Sales Admin của Vùng/ Phòng KD</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p class="line-height">
        <b class="txt-under">Điều 6:</b> <b>Thời gian và phạm vi áp dụng:</b>
      </p>
      <ul class="form-style2 style">
        <li>
          Quyết định này được áp dụng đối với Bộ phận Kinh doanh NextPay và Bộ phận khác ngoài Văn
          Phòng Hà Nội trên toàn quốc;
        </li>
        <li>
          Quyết định này được áp dụng từ ngày <b>25/11/2022</b> cho đến khi có văn bản khác thay
          thế.
        </li>
      </ul>
      <p class="line-height magb20">
        <b class="txt-under">Điều 7:</b> Các phòng ban và cá nhân có liên quan chịu trách nhiệm thực
        hiện quyết định này.
      </p>
      <p class="txt-right"><b class="fonsize-16">TỔNG GIÁM ĐỐC</b></p>
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped src="@/assets/css/style_hdsd.css"></style>

<style scoped>
  .container {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .contract {
    padding: 1rem !important;
    text-align: justify !important;
  }
  .head-contract.head-top table tr td {
    width: auto !important;
  }
</style>
